var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocationPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0349FF",
  fillRule: "nonzero",
  d: "M6.988 14.355q.055.082.113.168l4.343 5.184a.677.677 0 0 0 1.113 0l4.334-5.179q.061-.09.121-.168l.027-.04a6.07 6.07 0 0 0-1.106-7.841 5.97 5.97 0 0 0-7.866 0 6.07 6.07 0 0 0-1.106 7.841zM12 8.527c1.38 0 2.5 1.127 2.5 2.518s-1.12 2.517-2.5 2.517-2.5-1.127-2.5-2.517 1.12-2.518 2.5-2.518"
})));
export { SvgLocationPin as ReactComponent };
export default __webpack_public_path__ + "static/media/locationPin.8b670f7d.svg";